import { useTranslation } from "react-i18next";
import { emptySlot, useScheduleStore } from "../../stores/schedule-store";
import { dispatchScheduleEvent, endHistoryMerge } from "../../lib/schedule-history/dispatch";
import { cn } from "../../lib/utils";
import { ScheduleDragHandle } from "./ScheduleDragHandle";
import { useScheduleSwapRow } from "./use-schedule-swap-row";
import { StreamSlotForm } from "./StreamSlotForm";

export function StreamSlotRow({ slotKey, number, day }: { slotKey: string; number: number; day: string }) {
  const { t } = useTranslation();
  const slot = useScheduleStore(state => state.slots[slotKey] ?? emptySlot);
  const memberOnlyLabel = useScheduleStore(state => state.commonOptions.memberOnlyLabel) ?? t("schedule.memberOnly");
  const row = useScheduleSwapRow(slotKey, { kind: "slot", storeKey: slotKey });
  return <div ref={row.setNodeRef} style={row.style} data-swap-id={slotKey}>
    <StreamSlotForm slot={slot} number={number} day={day} memberOnlyLabel={memberOnlyLabel}
      onChange={(patch, field) => dispatchScheduleEvent({ type: "slot/set", key: slotKey, patch }, field ? `${slotKey}:${field}` : undefined)}
      onReset={() => dispatchScheduleEvent({ type: "slot/reset", key: slotKey })} onBlur={endHistoryMerge}
      dragHandle={<ScheduleDragHandle row={row} label={`${day}, ${t("schedule.slot", { number })}, ${t("schedule.dragSlot")}`} className="col-start-1 row-span-2 row-start-1 h-full self-stretch" />}
      className={cn(row.isDragging && "z-10 rounded bg-white opacity-100 shadow-sm ring-1 ring-neutral-300", row.isDropTarget && "rounded opacity-100 ring-2 ring-neutral-900 ring-offset-2")} />
  </div>;
}
